import { render, staticRenderFns } from "./LanguagesMenu.vue?vue&type=template&id=313296a2&scoped=true"
import script from "./LanguagesMenu.vue?vue&type=script&lang=js"
export * from "./LanguagesMenu.vue?vue&type=script&lang=js"
import style0 from "./LanguagesMenu.vue?vue&type=style&index=0&id=313296a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313296a2",
  null
  
)

export default component.exports